import React from "react";
import "./sectorLandingPage.scss";
import { useNavigate } from "react-router-dom";
import {
  MotifProgressLoader,
  MotifFormField,
  MotifSearch,
  MotifButton,
} from "@ey-xd/motif-react";
import { apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";
import logger from "../../common/utils/logger";

export const SectorLandingPage = () => {
  const [sectorName, setSectorName] = React.useState("");
  const [sectorData, setSectorData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = React.useState("");

  const filteredData = Object.values(
    sectorData?.filter((item) => {
      return item.sectorName.toLowerCase().includes(searchQuery.toLowerCase());
    })
  );

  React.useEffect(() => {
    setIsLoading(true);
    apiQueryWithToken
      .get(`api/Insights/all`)
      .then((data) => {
        setSectorData(data?.data.sectors);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          navigate("/");
        } else {
          logger.error("An error occurred:", error);
          setIsLoading(false);
        }
      });
  }, []);

  const handleOncLick = (id) => {
    setSectorName(id); 
    const previousSelectedElement = document.querySelector(".sector-selected");
    if (previousSelectedElement) {
      previousSelectedElement.classList.remove("sector-selected");
    }const selectedElement = document.getElementById(id);
    if (selectedElement) {
      selectedElement.classList.add("sector-selected");
    }
    navigate(`/sectors/dashboard/${id}`);
  };

  return (
    <React.Fragment>
      <div className="sector-container">
        <div className="sector-right">
          <div className="sector-right-heading">
            Please select a sector to proceed
            <div className="search-wrapper">
              <MotifFormField>
                <MotifSearch
                  aria-label="Search"
                  id="search"
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search"
                  value={searchQuery}
                />
              </MotifFormField>

            </div>
          </div>
          {isLoading ? (
            <div className="sectopage-loader">
              {" "}
              <MotifProgressLoader show variant="default" />{" "}
            </div>
          ) : (
            <div className="sector-wrapper">
              {filteredData?.map((sector) => {
                return (
                  <div
                    className="sector-box"
                    key={sector.sectorName}
                    id={sector.sectorName}
                    onClick={() => {
                      handleOncLick(sector.sectorName);
                    }}
                  >
                    <div className="sector-img">
                      <img
                        src={`data:image/jpeg;base64,${sector.image_URL}`}
                        alt={sector.sectorName}
                      />
                    </div>
                    <div className="sector-name">{sector.sectorName}</div>
                    <div className="sector-description">
                      <a
                        data-toggle="tooltip"
                        title={sector.description}
                        data-placement="top"
                      >
                        {sector.description}
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
